// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3Yzid","label":"Radio_label__2ZMwO","checkMark":"Radio_checkMark__3kZP5","disabled":"Radio_disabled__3RMc6"};